import type { useSingleton } from "@tippyjs/react";
import { useRef } from "react";
import { BOARD_META_FAVOURITE_SET_V2 } from "@/api/apiEndpoints";
import { canv } from "@/canv/global";
import { MakeRequest } from "@/canv/utils";
import { FavouriteIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import styles from "@/interface/HeaderBar/LeftBar/LeftBar.module.css";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    isFavourite: boolean;
};

export const FavouriteButton = ({ singletoneTarget, isFavourite }: Props) => {
    const setFavouriteLoadingRef = useRef(false);

    const handleFavouriteClick = () => {
        if (setFavouriteLoadingRef.current) {
            return;
        }
        setFavouriteLoadingRef.current = true;
        MakeRequest(
            BOARD_META_FAVOURITE_SET_V2,
            {
                boardUID: canv.getInitDataProp("boardUID"),
                token: canv.getInitDataProp("userToken"),
                isFavourite: !isFavourite,
            },
            true,
        )
            .then(() => {
                canv.setInitDataProp("isFavourite", !isFavourite);
            })
            .catch((e) => {
                console.log(e);
                canv.captureException(e);
            })
            .finally(() => {
                setFavouriteLoadingRef.current = false;
            });
    };

    return (
        <Tooltip
            singleton={singletoneTarget}
            content={isFavourite ? "Удалить из избранного" : "Добавить в избранное"}
        >
            <BottomBarItem onClick={handleFavouriteClick}>
                <FavouriteIcon className={isFavourite ? styles.favourite : undefined} />
            </BottomBarItem>
        </Tooltip>
    );
};
